import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_BIDDER } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeleteWorkspaceBidder, UseDeleteWorkspaceBidderProps } from './types'

export const useDeleteWorkspaceBidder = ({
  code,
}: UseDeleteWorkspaceBidderProps): UseDeleteWorkspaceBidder => {
  const { t } = useTranslation('features/globalSetup', { keyPrefix: 'prebid.bidders.list.delete' })
  const { enqueueSnackbar } = useSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_BIDDER,
    onCompleted: async (data: Data): Promise<void> => {
      const { deleteWorkspaceBidder: deleteBidder } = data

      if (deleteBidder) {
        const { errors } = deleteBidder

        if (errors && errors.length > 0) {
          enqueueSnackbar(t('action.error', { bidderCode: code }), { variant: 'error' })
        }
      } else {
        enqueueSnackbar(t('action.success', { bidderCode: code }), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getWorkspaceBiddersForTable'],
  })

  const deleteWorkspaceBidder: UseDeleteWorkspaceBidder['deleteWorkspaceBidder'] = id =>
    mutateAsync({ input: { id } })

  return { deleteWorkspaceBidder, loading }
}
